import StyledJumpAnchor from './styles';

import type { IJumpAnchor } from './types';

const JumpAnchor = ({ id }: IJumpAnchor) => (
  <StyledJumpAnchor id={id} />
);

export default JumpAnchor;
